import { Button, Flex } from '@chakra-ui/react';
import {
  ListingFragment,
  PublicListingFragment,
} from '@client/graphql/__generated__/types';
import { useEffect, useRef, useState } from 'react';
import { MapboxGeocoder } from '~/apps/consumer/components/MapboxGeocoder/MapboxGeocoder';
import { useExploreContext } from '~/apps/consumer/components/MapSearch/ExploreContext';
import { MobileFilterDrawer } from '~/apps/consumer/components/MapSearch/Filters/MobileFilterDrawer';
import { PropertyFilters } from '~/apps/consumer/components/MapSearch/Filters/PropertyFilters';
import { useIsMobile } from '~/common/hooks/useIsMobile';
import { getIntitialFilterValues } from '../../../BuyerOfferAnalysis/Comps/utils';

export const EditCompsMapFilters = ({
  geocoderInputRef,
  listing,
}: {
  geocoderInputRef?: React.RefObject<HTMLInputElement>;
  listing?: ListingFragment | PublicListingFragment;
}) => {
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const isMobile = useIsMobile();

  const { mapRef, handleRetrieve, updateFilters, clearFilters } =
    useExploreContext();
  const containerRef = useRef<HTMLDivElement>(null);
  const mobileBtnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (listing) {
      const initialFilterValues = getIntitialFilterValues(listing);
      updateFilters(initialFilterValues);
    }
  }, [listing, updateFilters]);

  return (
    <Flex
      alignItems="center"
      background="black"
      borderBottom="1px solid"
      borderBottomColor="whiteAlpha.100"
      borderRadius="8px"
      gap={4}
      justifyContent="space-between"
      left="10px"
      mr={{ base: '10px', md: 0 }}
      position="absolute"
      pr={{ base: 2, md: 0 }}
      top="10px"
      width={{ base: 'calc(100% - 20px)', md: 'auto' }}
      zIndex="3"
    >
      <Flex
        grow={1}
        maxWidth={{ base: undefined, md: '350px' }}
        minWidth={{ base: undefined, md: '350px' }}
      >
        <MapboxGeocoder
          _focusVisible={{
            border: 'none',
          }}
          bg="transparent"
          border="none"
          borderRadius="none"
          height={{ base: '48px', md: '56px' }}
          inputRef={geocoderInputRef}
          mapRef={mapRef}
          ml={{ base: 2, md: 2 }}
          onRetrieve={handleRetrieve}
        />
      </Flex>
      <Flex ref={containerRef} gap={2}>
        {isMobile ? (
          <Button
            borderColor="whiteAlpha.300"
            color="white"
            size="sm"
            variant="outline"
            onClick={() => setShowMobileFilters(true)}
          >
            Filters
          </Button>
        ) : (
          <PropertyFilters containerRef={containerRef} />
        )}
      </Flex>
      {isMobile && (
        <MobileFilterDrawer
          btnRef={mobileBtnRef}
          clearAll={() => {
            clearFilters();
          }}
          filtersToShow={['property']}
          isOpen={showMobileFilters}
          onClose={() => setShowMobileFilters(false)}
        />
      )}
    </Flex>
  );
};
